import { noop } from 'lodash';
import { localStorage } from '@fiverr-private/futile';
import { KEY_CODE } from '../../constants';

const VOLUME_STORAGE_KEY = 'assets-sharing-audio-volume';
const DEFAULT_VOLUME = 0.8;

const handlePressEvents = (
    keyPressed = noop,
    togglePlayCallback = noop,
    seekCallback = noop,
    setVolumeCallback = noop,
    currentVolume = 0.0
) => {
    switch (keyPressed) {
        case KEY_CODE.SPACE_BAR: {
            togglePlayCallback();
            break;
        }
        case KEY_CODE.ARROW_RIGHT: {
            seekCallback(2);
            break;
        }
        case KEY_CODE.ARROW_LEFT: {
            seekCallback(-2);
            break;
        }
        case KEY_CODE.ARROW_UP: {
            setVolumeCallback(currentVolume + 0.2);
            break;
        }
        case KEY_CODE.ARROW_DOWN: {
            setVolumeCallback(currentVolume - 0.2);
            break;
        }
        default: {
            break;
        }
    }
};

const validVolume = (volume) => typeof volume === 'number' && volume >= 0 && volume <= 1;

const loadVolume = () => {
    const preferenceVolume = localStorage.get(VOLUME_STORAGE_KEY);
    const newVolume = validVolume(preferenceVolume) ? preferenceVolume : DEFAULT_VOLUME;

    return newVolume;
};

const storeVolume = (volume) => {
    if (validVolume(volume)) {
        localStorage.set(VOLUME_STORAGE_KEY, volume);
    }
};

const padWithZeros = (numericString, length) => (new Array(length + 1).join('0') + numericString).slice(-length);

const audioDurationToText = (duration) => {
    if (typeof duration !== 'number') {
        return '00:00';
    }

    const minutes = Math.floor(duration / 60);
    const seconds = Math.floor(duration - minutes * 60);
    return `${padWithZeros(minutes, 2)}:${padWithZeros(seconds, 2)}`;
};

export { handlePressEvents, validVolume, loadVolume, storeVolume, audioDurationToText };
